import { useTranslation } from 'react-i18next';
import { NavigationPageItem } from '@cbridge-utils/navigation';
import { RouteSegments, useClientPageVisibility } from '@cbridge-packages/routing-client-admin';
import {
  ExternalReportingNavigationIcon,
  MarkupsNavigationIcon,
  OrderRoutingNavigationIcon,
  PricingSettingsNavigationIcon,
  ProfilesNavigationIcon,
  SymbolsNavigationIcon,
} from '@cbridge-tools/icons';

export const useConfigNavigationItems = () => {
  const { t } = useTranslation();
  const { isTradingVisible, isExternalReportingVisible } = useClientPageVisibility();

  const items: NavigationPageItem[] = [
    {
      kind: 'page',
      segment: RouteSegments.Config.Symbols,
      pattern: [
        `${RouteSegments.Config.Symbols}{/*path}`,
        `${RouteSegments.Pools.Symbols}{/*path}`,
        `${RouteSegments.Servers.Symbols}{/*path}`,
        `${RouteSegments.Lps.Symbols}{/*path}`,
      ],
      icon: <SymbolsNavigationIcon />,
      title: t('text:navigation.config.symbols.title'),
    },
    // Markups and Order Routing configure trading: hidden without the basicBridge feature
    ...(isTradingVisible ? [{
      kind: 'page' as const,
      segment: RouteSegments.Config.Markups,
      pattern: `${RouteSegments.Config.Markups}{/*path}`,
      icon: <MarkupsNavigationIcon />,
      title: t('text:navigation.config.markups'),
    }, {
      kind: 'page' as const,
      segment: RouteSegments.Config.OrderRouting,
      pattern: [
        `${RouteSegments.Config.Rules}/${RouteSegments.Rules.OrderRouting}{/*path}`,
        `${RouteSegments.Config.Rules}/${RouteSegments.Rules.OrderLifetime}{/*path}`,
        `${RouteSegments.Config.Rules}/${RouteSegments.Rules.Adjustment}{/*path}`,
      ],
      icon: <OrderRoutingNavigationIcon />,
      title: t('text:navigation.config.orderRouting.title'),
    }] : []),
    {
      kind: 'page',
      segment: RouteSegments.Config.PricingSettings,
      pattern: [
        `${RouteSegments.Config.Rules}/${RouteSegments.Rules.PricingRules}{/*path}`,
        `${RouteSegments.Config.Rules}/${RouteSegments.Rules.PriceFilteringRules}{/*path}`,
      ],
      icon: <PricingSettingsNavigationIcon />,
      title: t('text:navigation.config.pricingSettings.title'),
    },
    {
      kind: 'page',
      segment: RouteSegments.Config.Profiles,
      pattern: `${RouteSegments.Config.Profiles}{/*path}`,
      icon: <ProfilesNavigationIcon />,
      title: t('text:navigation.config.profiles.title'),
    },
    // External Reporting (coverage) — gated by the externalReporting feature and basicBridge
    ...(isExternalReportingVisible ? [{
      kind: 'page' as const,
      segment: RouteSegments.Config.ExternalReporting,
      pattern: `${RouteSegments.Config.ExternalReporting}{/*path}`,
      icon: <ExternalReportingNavigationIcon />,
      title: t('text:navigation.config.externalReporting.title'),
    }] : []),
  ];

  return items;
};
